export class AppengineHealth {
  public static PLATFORM = 'App Engine Service';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/appengine/common/appengineHealth.ts